import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, FormControl, Validators, ControlContainer, FormGroupDirective } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { FeesEstimationAdminService } from '../../shared/services/fees-estimation-admin.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { User } from 'src/app/front-user/shared/models/user.model';
import { FeesEstimationAdminDto } from '../../shared/models/fees-estimation-admin.model';
import { FormMode, ServiceStatus } from 'src/app/shared/models/enums.model';
import { FeesEstimate } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimate.model';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { MarineOfficerFeesComponent } from '../marine-officer-fees/marine-officer-fees.component';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { FeesEstimationService } from 'src/app/front-user/services/e-booking/fees-estimation-request/fees-estimation.service';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';

@Component({
  selector: 'app-manager-confirm-fees',
  templateUrl: './manager-confirm-fees.component.html',
  styleUrls: ['./manager-confirm-fees.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }]
})
export class ManagerConfirmFeesComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  managerForm: FormGroup;
  user: User = new User();
  showRequest = false;
  MeasurmentOffcierObject: FeesEstimationAdminDto = new FeesEstimationAdminDto();
  displayedLang: string;
  requestStatus: number;
  agentId: string;
  //public formMode: FormMode.Readonly;
  public FormMode: any = FormMode;
  public formMode = FormMode.Add;
  feesEstimationObj: FeesEstimate = new FeesEstimate();
  marineRequirements: string;
  baseRequestDTO: BaseRequest //= new BaseRequest();
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';

  @ViewChild('marineRequest',{static: false}) marineRequest: MarineOfficerFeesComponent;
  isErrorMessage: boolean = false;
  lockTaskErrorMessage: boolean =false;

  constructor(private formBuilder: FormBuilder,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private feesSrv: FeesEstimationAdminService, private feesEstimationService: FeesEstimationService, private translate: TranslateService, ) {
    //this.baseRequestId = this.route.snapshot.params.Id;
    this.user = this.globalSrv.user;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }
  }

  ngOnInit() {
    this.buildForm();
  }
  // receiveMarine(loaded: boolean) {
  //
  //   if(loaded){
  //     this.MeasurmentOffcierObject.FeeValue = this.marineRequest.measurementObj.FeeValue;
  //     this.MeasurmentOffcierObject.InsuranceValue =this.marineRequest.measurementObj.InsuranceValue;
  //     this.MeasurmentOffcierObject.MarineRequirements =this.marineRequest.marineRequirements;
  //   }
  // }
  buildForm() {
    this.managerForm = this.formBuilder.group({
      TotalFees: new FormControl('', [Validators.required,CustomValidators.textSpaceValidator(), Validators.pattern(this.numberRegex)]),
    });
  }

  get f() {
    return this.managerForm.controls;
  }

  getBaseRequest() {
    this.feesEstimationService.get(this.baseRequestId).pipe(first()).subscribe(
      d => {
        if (d.Success) {
          this.feesEstimationObj = d.Data;
          this.requestStatus = this.feesEstimationObj.StatusId;
          this.agentId = this.feesEstimationObj.RequestorId;
          if (history.state.data && history.state.data.isCompleted) {
            this.formMode = FormMode.Readonly;
            this.managerForm.disable();
            this.managerForm.patchValue({
              TotalFees: this.feesEstimationObj.TotalFees,
            });
          }
         else if (this.requestStatus == ServiceStatus.PendingonMeasurementsDepartmentManagerApproval) {
            this.formMode = FormMode.Add;
            this.managerForm.enable();
          }
          else {
            this.formMode = FormMode.Readonly;
            this.managerForm.disable();
            this.managerForm.patchValue({
              TotalFees: this.feesEstimationObj.TotalFees,
            });
          }

        }

      }
    )
  }

  onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.managerForm.invalid) {
      return;
    }
    this.loading = true;
    this.globalSrv.isLoaderEnabled = true;
    this.MeasurmentOffcierObject = this.managerForm.value;
    this.MeasurmentOffcierObject.FeeValue = this.marineRequest.measurementRequest.measurementOfficerForm.controls.FeeValue.value;
    this.MeasurmentOffcierObject.InsuranceValue = this.marineRequest.measurementRequest.measurementOfficerForm.controls.InsuranceValue.value;
    this.MeasurmentOffcierObject.MeasurementDescription = this.marineRequest.measurementRequest.measurementOfficerForm.controls.MeasurementDescription.value;
    this.MeasurmentOffcierObject.MarineRequirements = this.marineRequest.marineOfficerForm.controls.MarineRequirements.value;

    this.MeasurmentOffcierObject.AdminEmail = this.user.UserName;
    this.MeasurmentOffcierObject.RequestId = this.baseRequestId;

    this.feesSrv.fillManagerFees(this.MeasurmentOffcierObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.managerForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if(data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser")!=null){
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);
            this.loading = false;
          }

        });
  }

}
